(app => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Settings.CRMSetup.CustomFields",
            {
                url: "/CustomFields",
                component: "customFields",
                data: {
                    pageTitle: "CustomFields"
                }
            });
    });

    app.component("customFields",
        {
            templateUrl: "/App/Settings/CRMSetup/CustomFields/custom-fields-template.html",
            controller: customFieldsController,
            bindings: {
                currentUser: "<"
            }
        });

    function customFieldsController(customFieldApi, customFieldsDataTable) {
        const $ctrl = this;

        const getCustomFields = (nextPageToken) => {
            return customFieldApi.getAllCustomFields()
                .then((response) => {
                    return $ctrl.customFields = removeHidden(response);
                });
        };

        //remove Hidden fields for now, may reenable later
        const removeHidden = (customFields) => {
           return _.filter(customFields, function (field) { return field.IsActive; });
        };

        $ctrl.$onInit = () => {
        $ctrl.customFields = [];
            $ctrl.loading = true;

            getCustomFields().then(response => {
                $ctrl.customFields = response;
                $ctrl.dataTableOptions = customFieldsDataTable.buildDataTableOptions($ctrl.customFields, $ctrl.currentUser);
            })
                .finally(() => {
                $ctrl.loading = false;
                });

        };
    }

})(window.app);